// extracted by mini-css-extract-plugin
module.exports = {"root":"header_root__jAsW3","dropdown":"header_dropdown__WoLt_","login":"header_login__QPCwP"};